import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function GlobalLevelCard({ niveauGlobal, loading }) {
  const formatAmount = (value) => {
    if (value === null || value === undefined) return "0,00 €";
    const num = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(num)) return "0,00 €";
    const sign = num >= 0 ? "+" : "-";
    return sign + Math.abs(num).toFixed(2).replace(".", ",") + " €";
  };

  const isPositive = niveauGlobal >= 0;
  const displayValue = formatAmount(niveauGlobal);

  if (loading) {
    return (
      <Card>
        <MDBox p={3} textAlign="center">
          <MDTypography variant="h6" fontWeight="medium" color="text">
            Chargement...
          </MDTypography>
        </MDBox>
      </Card>
    );
  }

  return (
    <Card
      sx={{
        background: isPositive
          ? "linear-gradient(135deg, #66BB6A 0%, #43A047 100%)"
          : "linear-gradient(135deg, #EF5350 0%, #E53935 100%)",
        boxShadow: isPositive
          ? "0 8px 24px rgba(76, 175, 80, 0.3)"
          : "0 8px 24px rgba(244, 67, 54, 0.3)",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: "-50%",
          right: "-20%",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background: "rgba(255, 255, 255, 0.1)",
        },
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: "-30%",
          left: "-10%",
          width: "200px",
          height: "200px",
          borderRadius: "50%",
          background: "rgba(255, 255, 255, 0.08)",
        },
      }}
    >
      <MDBox p={{ xs: 1.5, sm: 2 }} position="relative" zIndex={1}>
        <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={1}>
          <MDBox>
            <MDTypography
              variant="button"
              fontWeight="medium"
              color="white"
              sx={{
                opacity: 0.8,
                textTransform: "uppercase",
                letterSpacing: "1px",
                fontSize: { xs: "0.65rem", sm: "0.75rem" },
              }}
            >
              Niveau Global
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              width: { xs: "1.8rem", sm: "2.2rem" },
              height: { xs: "1.8rem", sm: "2.2rem" },
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.25)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backdropFilter: "blur(10px)",
            }}
          >
            <Icon
              sx={{
                color: "white",
                fontSize: { xs: "1rem", sm: "1.3rem" },
              }}
            >
              {isPositive ? "trending_up" : "trending_down"}
            </Icon>
          </MDBox>
        </MDBox>

        <MDBox textAlign="center" mb={0.5}>
          <MDTypography
            variant="h1"
            fontWeight="bold"
            color="white"
            sx={{
              fontSize: { xs: "1.3rem", sm: "1.5rem", md: "1.8rem" },
              textShadow: "0 2px 10px rgba(0,0,0,0.2)",
            }}
          >
            {displayValue}
          </MDTypography>
        </MDBox>

        <MDBox
          textAlign="center"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <MDBox
            sx={{
              width: "6px",
              height: "6px",
              borderRadius: "50%",
              backgroundColor: "white",
              animation: "pulse 2s infinite",
              "@keyframes pulse": {
                "0%, 100%": { opacity: 1 },
                "50%": { opacity: 0.5 },
              },
            }}
          />
          <MDTypography
            variant="button"
            fontWeight="medium"
            color="white"
            sx={{
              opacity: 0.95,
              fontSize: { xs: "0.7rem", sm: "0.8rem" },
            }}
          >
            {isPositive ? "Solde positif" : "Solde négatif"}
          </MDTypography>
        </MDBox>
      </MDBox>
    </Card>
  );
}

GlobalLevelCard.propTypes = {
  niveauGlobal: PropTypes.number,
  loading: PropTypes.bool,
};

GlobalLevelCard.defaultProps = {
  niveauGlobal: 0,
  loading: false,
};

export default GlobalLevelCard;
